import type { GasProperties } from "@/libs/calculations/fluidProperties/d";
import { withoutAbsentGasComponents } from "@/libs/calculations/gasPhase/gasTable";

// PVT!AI95:AI108 summed — the Peng Robinson liquid density of each component
export function condensateDensityCalculator(
  gasProperties: GasProperties[]
): number {
  const sum = withoutAbsentGasComponents(gasProperties).reduce(
    (total, component) => total + (component.yCondensateDensity || 0),
    0
  );
  return Number.isFinite(sum) && sum > 0 ? sum : 0;
}
